import { Modal, ModalBody, ModalFooter, Button, Text } from '@customerio/pluma-components/react';

interface ReleaseNotificationModalProps {
  isOpen: boolean;
  onReload: () => void;
}

export function ReleaseNotificationModal({ isOpen, onReload }: ReleaseNotificationModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onReload} isDismissable={false} title="New Release Ready!">
      <ModalBody>
        <Text>
          We're now ready to load the new version, and will bring you right back to this page in a few seconds.
        </Text>
      </ModalBody>
      <ModalFooter>
        <Button variant="primary" onClick={onReload}>
          Let's go!
        </Button>
      </ModalFooter>
    </Modal>
  );
}
